module.exports = ".items-container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap; }\n\n.align-end {\n  justify-content: flex-end; }\n"